// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-container[data-v-53e91b35]{height:100vh;padding-top:88px;padding-bottom:56px}", ""]);
// Exports
module.exports = exports;
